export default {"src":"/_next/static/media/matterport-retail.6183d7a8.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};